import { FormikProps } from 'formik';
import { CardBody, CardHeader, Col, FormGroup, Input, Label } from 'reactstrap';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import { RootState } from 'slices';
import { CustomReactSelectStyles } from 'styles/common/singleSelectStyle';
import { useTranslation } from 'react-i18next';
import {
  CustomerFinancialInfo,
  CustomerFormType,
} from 'types/customer/customerTypes';
import { useMemo } from 'react';
import { convertGroupPriceToOptions } from 'utils/mappers/customerMapper';
import { TaxableOptions } from 'pages/Customers/CustomerManagementModals/constants';
import useWindowSize from 'Components/Hooks/WindowSizeHook';

type Option = { label: string; value: string };

export default function CustomerFinancialSection({
  formik,
}: {
  formik: FormikProps<CustomerFormType>;
}) {
  const { t } = useTranslation();
  const { width } = useWindowSize();
  const isMobile = width <= 1024;
  const isDarkMode =
    useSelector((state: RootState) => state.Layout.layoutModeType) === 'dark';
  const { showAllValidateErrors } = useSelector((s: RootState) => s.Customer);

  const productFormState = useSelector((state: RootState) => state.Product);
  const { group_price } = productFormState.form.pageConfig;

  const groupPriceOptions = useMemo(() => {
    return convertGroupPriceToOptions(group_price);
  }, [group_price]);

  const err = (path: keyof CustomerFinancialInfo) =>
    ((formik.touched.customerFinancialInfo as any)?.[path] &&
      (formik.errors.customerFinancialInfo as any)?.[path] &&
      typeof (formik.errors.customerFinancialInfo as any)[path] === 'string') ||
    (formik.isValid === false &&
      (formik.errors.customerFinancialInfo as any)?.[path] &&
      showAllValidateErrors === true);

  const getOpt = (opts: Option[], value?: string) =>
    value ? (opts.find((o) => o.value === value) ?? null) : null;

  return (
    <>
      {/* <div className="mb-3" style={{ fontSize: '16px', fontWeight: '600' }}> */}
      {/* <div className="mb-4 accent-bar">{t('Financial Information')}</div> */}
      <CardHeader className="mb-4 mx-0 px-0">
        <div
          className="px-0 mx-0"
          style={{
            fontSize: '1rem',
            fontWeight: '600',
            display: 'inline-flex',
          }}
        >
          <div className={`text-success`}>
            <i className="ri-user-settings-line"></i>
          </div>
          <div className="px-1">{t('Financial Information')}</div>
        </div>
      </CardHeader>
      <CardBody
        style={{
          paddingLeft: isMobile ? '' : '2rem',
          paddingRight: isMobile ? '' : '2rem',
        }}
      >
        <div className="mb-3 row">
          <Label
            htmlFor="customerFinancialInfo.groupPrice"
            className="col-sm-3 col-form-label"
          >
            {t('Product Price Group')}
          </Label>
          <Col sm={9}>
            <Select
              styles={CustomReactSelectStyles(isDarkMode)}
              inputId="customerFinancialInfo.groupPrice"
              name="customerFinancialInfo.groupPrice"
              options={groupPriceOptions}
              value={getOpt(
                groupPriceOptions,
                formik.values.customerFinancialInfo.groupPrice
              )}
              onChange={(opt: any) => {
                formik
                  .setFieldValue(
                    'customerFinancialInfo.groupPrice',
                    opt?.value ?? ''
                  )
                  .then(() =>
                    formik.setFieldTouched(
                      'customerFinancialInfo.groupPrice',
                      true
                    )
                  );
              }}
              onBlur={() =>
                formik.setFieldTouched('customerFinancialInfo.groupPrice', true)
              }
              placeholder={t('Select group')}
            />
            {err('groupPrice') ? (
              <div className="text-danger">
                {(formik.errors.customerFinancialInfo as any).groupPrice}
              </div>
            ) : null}
          </Col>
        </div>

        {/* <div className="mb-2 row">
        <Label className="col-sm-3 col-form-label">{t('Taxes')}</Label>
        <Col sm={9}>
          <FormGroup className="mt-2">
            <Input
              id="isTaxable"
              type="checkbox"
              name="isTaxable"
              defaultChecked={
                formik.values.customerFinancialInfo.isTaxable !== false
              }
              onChange={formik.handleChange}
              className="me-2"
            />
            <Label htmlFor="isTaxable" className="mb-0">
              {t('Taxable')}
            </Label>
          </FormGroup>
          {err('isTaxable') ? (
            <div className="text-danger">
              {(formik.errors.customerFinancialInfo as any).isTaxable}
            </div>
          ) : null}
        </Col>
      </div> */}

        <div className="mb-1 row">
          <Label
            htmlFor="customerFinancialInfo.isTaxable"
            className="col-sm-3 col-form-label"
          >
            {t('Taxable')}
          </Label>
          <Col sm={9}>
            <div className="mt-2">
              <FormGroup key={1}>
                {TaxableOptions(t).map(
                  (p: { label: string; value: string }, _index) => (
                    <div key={p.value} className="form-check form-check-inline">
                      <Input
                        className="form-check-input"
                        type="radio"
                        name="customerFinancialInfo.isTaxable"
                        id={p.label}
                        value={p.value}
                        checked={
                          formik.values.customerFinancialInfo.isTaxable ===
                          p.value
                        }
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                        onBlur={(e) => {
                          formik.handleBlur(e);
                        }}
                      />
                      <Label className="form-check-label" htmlFor={p.label}>
                        {p.label}
                      </Label>
                    </div>
                  )
                )}
              </FormGroup>
            </div>
          </Col>
        </div>
        <div className="mb-3 row"></div>
      </CardBody>
    </>
  );
}
